<app-alert></app-alert>
<section class="panel panel-default">

  <div class="card-header">
    <title>Register of Investor Complaints</title>
    <span class="cat__core__title">
      <strong id="pageTitle">Register of Investor Complaints</strong>
    </span>

    <span style="float: right">
      <!-- <a routerLink="/masterinvestorcomplaints"> -->
        <button (click)="back()" class="btn btn-sm btn-default pull-right btn-back" type="button">
          <i class=" fa fa-chevron-circle-left"></i>
          Back
        </button>
      <!-- </a> -->
    </span>
    
    <!-- <span style="float:right">
      <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button" *ngIf="restrictTabflag">
        <span>
          <i class="fa fa-save"></i>Generate Output</span>
      </button>
</span> -->
  </div>

  
    <form [formGroup]='investorComplaintForm' (document:click)="a.close();b.close();c.close();d.close();e.close();f.close();g.close()">
        <div class="modal-body">
      <div class="row">
        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Date of receipt of complaint</label>
          <span _ngcontent-c2="" style="color: red;">*</span>
          <div class="input-group" (click)="$event.stopPropagation()">
            <input class="form-control" [maxDate]="TodayDate"
              [formControl]="investorComplaintForm.controls['dateOfReceiptOfComplaint']"
              [(ngModel)]="dateOfReceiptOfComplaintModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
              name="receiptdate" ngbDatepicker #a="ngbDatepicker"
              (click)="a.toggle()">
            <button class="input-group-addon"
              (click)="a.toggle()" type="button">
              <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
            </button>
          </div>
          <div
            *ngIf="investorComplaintForm.controls['dateOfReceiptOfComplaint'].hasError('required') && investorComplaintForm.controls['dateOfReceiptOfComplaint'].touched"
            class="form-control-error-custom">
            Date of receipt of complaint is required
          </div>
        </div>
        <div class="form-group  col-md-4 col-sm-6 col-xs-12">
          <label>Nature of complaint</label>
          <input type="text" class="form-control" [formControl]="investorComplaintForm.controls.natureOfComplaint">
        </div>
        <div class="form-group  col-md-4 col-sm-6 col-xs-12">
          <label>Name of the person lodging the complaint</label>
          <input type="text" class="form-control"
            [formControl]="investorComplaintForm.controls.nameOfThePersonLodgingTheComplaint">
          <div *ngIf="investorComplaintForm.controls['nameOfThePersonLodgingTheComplaint'].hasError('pattern')"
            class="form-control-error-custom">
            Name of the person lodging the complaint is invalid.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Deposit receipt number</label>
          <input type="text" class="form-control" [formControl]="investorComplaintForm.controls.depositReceiptNumber">
          <div *ngIf="investorComplaintForm.controls['depositReceiptNumber'].hasError('pattern')"
            class="form-control-error-custom">
            Deposit receipt number is invalid.
          </div>
        </div>
        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Folio number</label>
          <input type="text" class="form-control" [formControl]="investorComplaintForm.controls.folioNumber">
          <div *ngIf="investorComplaintForm.controls['folioNumber'].hasError('pattern')"
            class="form-control-error-custom">
            Folio number is invalid.
          </div>
        </div>
        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Client ID number</label>
          <input type="text" class="form-control" [formControl]="investorComplaintForm.controls.clientIdNumber">
          <div *ngIf="investorComplaintForm.controls['clientIdNumber'].hasError('pattern')"
            class="form-control-error-custom">
            Client ID number is invalid.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Date of interim reply, if any</label>
          <div class="input-group" (click)="$event.stopPropagation()">
            <input class="form-control" [maxDate]="TodayDate"
              [formControl]="investorComplaintForm.controls['dateOfInterimReplyIfAny']"
              [(ngModel)]="dateOfInterimReplyIfAnyModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
              name="interimdate" ngbDatepicker #b="ngbDatepicker"
              (click)="b.toggle()">
            <button class="input-group-addon"
              (click)="b.toggle()" type="button">
              <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
            </button>
          </div>
        </div>
        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Date on which complaint was fully satisfied </label>
          <div class="input-group" (click)="$event.stopPropagation()">
            <input class="form-control" [maxDate]="TodayDate"
              [formControl]="investorComplaintForm.controls['dateOnWhichComplaintWasFullySatisfied']"
              [(ngModel)]="dateOnWhichComplaintWasFullySatisfiedModel" style="padding:6px;z-index: 0;"
              placeholder="dd-mm-yyyy" name="complaintdate" ngbDatepicker #c="ngbDatepicker"
              (click)="c.toggle()">
            <button class="input-group-addon"
              (click)="c.toggle()" type="button">
              <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
            </button>
          </div>
        </div>
        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Time taken for resolving complaints</label>
          <input type="text" class="form-control"
            [formControl]="investorComplaintForm.controls.timeTakenForResolvingComplaints">
        </div>
      </div>

      <section class="panel panel-default">
        <div class="panel-heading">
          <h5 class="panel-title">Date of forwarding the copy of satisfaction of complaint</h5>
        </div>
        <div class="panel-body">
          <div class="row">
            <div class="form-group col-md-4 col-sm-6 col-xs-12">
              <label>ROC</label>
              <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" [maxDate]="TodayDate" [formControl]="investorComplaintForm.controls['roc']"
                  [(ngModel)]="rocModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="rocdate"
                  ngbDatepicker #d="ngbDatepicker"
                  (click)="d.toggle()">
                <button class="input-group-addon"
                  (click)="d.toggle()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
              </div>
            </div>
            <div class="form-group col-md-4 col-sm-6 col-xs-12">
              <label>Stock Exchange</label>
              <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" [maxDate]="TodayDate"
                  [formControl]="investorComplaintForm.controls['stockExchange']" [(ngModel)]="stockExchangeModel"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="stockexchangedate" ngbDatepicker
                  #e="ngbDatepicker" (click)="e.toggle()">
                <button class="input-group-addon"
                  (click)="e.toggle()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
              </div>
            </div>
            <div class="form-group col-md-4 col-sm-6 col-xs-12">
              <label>SEBI</label>
              <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" [formControl]="investorComplaintForm.controls['sebi']"
                  [(ngModel)]="sebiModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="sebidate"
                  ngbDatepicker #f="ngbDatepicker"
                  (click)="f.toggle()">
                <button class="input-group-addon"
                  (click)="f.toggle()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section class="panel panel-default">
        <div class="panel-heading">
          <h5 class="panel-title">Other Regulatory</h5>
        </div>
        <div class="panel-body">
          <div class="row">
            <div class="form-group col-md-4 col-sm-6 col-xs-12">
              <label>Name of regulatory</label>
              <input type="text" class="form-control" [formControl]="investorComplaintForm.controls.nameOfRegulatory">
              <div *ngIf="investorComplaintForm.controls['nameOfRegulatory'].hasError('pattern')"
                class="form-control-error-custom">
                Name of regulatory is invalid.
              </div>
            </div>
            <div class="form-group col-md-4 col-sm-6 col-xs-12">
              <label>Date</label>
              <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" [maxDate]="TodayDate"
                  [formControl]="investorComplaintForm.controls['dateOfOtherRegulatory']"
                  [(ngModel)]="dateOfOtherRegulatoryModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                  name="dateOfOtherRegulatory" ngbDatepicker #g="ngbDatepicker"
                  (click)="g.toggle();">
                <button class="input-group-addon"
                  (click)="g.toggle();" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
              </div>
            </div>
            <div class="form-group col-md-4 col-sm-6 col-xs-12">
              <label>Remarks, if any</label>
              <textarea class="form-control" [formControl]="investorComplaintForm.controls.remarks"
                maxlength="200"></textarea>
            </div>
          </div>
        </div>
      </section>
        </div>
        <div class="card-footer" align="right">
    
        <div class="form-group"  *ngIf="!restrictTabflag">
          <button id="btnsave" type="button" class="btn-sm btn btn-primary" [disabled]="!(investorComplaintForm.valid) || disabledOnclick"
            (click)="investorEntry()">
            <span id="saveUpdate"></span> <i class="fa fa-save"></i>&nbsp;Save
          </button>
        </div>
        <div class="form-group"  *ngIf="restrictTabflag">
          <button class="btn btn-sm btn-primary" (click)="updateInvestorComplaints()" type="button"
            [disabled]="!investorComplaintForm.valid || disabledOnclick">
            <span id="saveUpdate">
              <i class="fa fa-save"></i>&nbsp;
              Update
            </span>
          </button>
        </div>
      </div>
    </form>
  

</section>